const userEnums = {
    UserStatusTypes: Object.freeze({
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
      DISABLED: 'Disabled',
    }),
  
  };
  
  module.exports = userEnums;
  